'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Promise based implementation of XMLHttpRequest Level 2 for GET method.
 */
var Loader = function () {
  /**
   * @constructs
   * @param {string} [responseType=""] - responseType's value, "text" (equal to ""), "arraybuffer", "blob", "document" or "json"
   */
  function Loader() {
    var responseType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    (0, _classCallCheck3.default)(this, Loader);

    /**
     * @type {string}
     * @private
     */
    this.responseType = responseType;

    /**
     * @type {function}
     * @private
     */
    this.progressCb = undefined;
  }

  /**
   * Method for a promise based file loading.
   * Internally switch between loadOne and loadAll.
   * @public
   * @param {(string|string[])} fileURLs - The URL(s) of the files to load. Accepts a URL pointing to the file location or an array of URLs.
   * @returns {Promise}
   */


  (0, _createClass3.default)(Loader, [{
    key: 'load',
    value: function load(fileURLs) {
      if (fileURLs === undefined) throw new Error('Invalid fileURLs parameter: load method needs at least a url to load');

      if (Array.isArray(fileURLs)) return this.loadAll(fileURLs);else return this.loadOne(fileURLs);
    }

    /**
     * Load a single file
     * @private
     * @param {string} fileURL - The URL of the file to load.
     * @returns {Promise}
     */

  }, {
    key: 'loadOne',
    value: function loadOne(fileURL) {
      return this.fileLoadingRequest(fileURL);
    }

    /**
     * Load all files at once in a single array and return a Promise
     * @private
     * @param {string[]} fileURLs - The URLs array of the files to load.
     * @returns {Promise}
     */

  }, {
    key: 'loadAll',
    value: function loadAll(fileURLs) {
      var _this = this;

      var promises = fileURLs.map(function (fileURL, index) {
        return _this.fileLoadingRequest(fileURL, index);
      });

      return _promise2.default.all(promises);
    }

    /**
     * Load a file asynchronously, return a Promise.
     * @private
     * @param {string} url - The URL of the file to load
     * @param {string} [index] - The index of the file in the array of files to load
     * @returns {Promise}
     */

  }, {
    key: 'fileLoadingRequest',
    value: function fileLoadingRequest(url, index) {
      var _this2 = this;

      var promise = new _promise2.default(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.index = index;

        if (_this2.responseType) {
          request.responseType = _this2.responseType;
        } else {
          var suffix = '.json';
          if (url.indexOf(suffix, _this2.length - suffix.length) !== -1) {
            request.responseType = 'json';
          } else {
            request.responseType = 'arraybuffer';
          }
        }

        request.addEventListener('load', function () {
          // Test request.status value, as 404 will also get there
          // Test request.status === 0 for cordova internal ajax calls
          if (request.status === 200 || request.status === 304 || request.status === 0) {
            // Hack for iOS 7, to remove as soon as possible
            if (this.responseType === 'json' && typeof request.response === 'string') request.response = JSON.parse(request.response);

            resolve(request.response);
          } else {
            reject(new Error(request.statusText));
          }
        });

        request.addEventListener('progress', function (evt) {
          if (_this2.progressCallback) {
            var event = {
              value: evt.loaded / evt.total,
              loaded: evt.loaded,
              total: evt.total
            };

            if (index !== undefined) event.index = index;

            _this2.progressCallback(event);
          }
        });
        // Manage network errors
        request.addEventListener('error', function () {
          reject(new Error('Network Error'));
        });

        request.send();
      });

      return promise;
    }

    /**
     * Alternative API to set the progress callback.
     * @type {function} callback - The callback that handles the response.
     */

  }, {
    key: 'onProgress',
    value: function onProgress(callback) {
      this.progressCb = callback;
    }

    /**
     * Get the callback function to get the progress of file loading process.
     * This is only for the file loading progress as decodeAudioData doesn't
     * expose a decode progress value.
     * @type {function}
     */

  }, {
    key: 'progressCallback',
    get: function get() {
      return this.progressCb;
    }

    /**
     * Set the callback function to get the progress of file loading process.
     * This is only for the file loading progress as decodeAudioData doesn't
     * expose a decode progress value.
     * @type {function} callback - The callback that handles the response.
     */
    ,
    set: function set(callback) {
      this.progressCb = callback;
    }
  }]);
  return Loader;
}();

exports.default = Loader;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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